import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { AreaScreen } from "../../screens/library/AreaScreen.tsx";

/** `/areas/:id`: one business area with its dashboards, questions, lists and measures together. */
export const Route = createFileRoute("/_app/areas/$groupId")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("library.get", {})),
  component: AreaScreen,
});
